import React, {  useState } from "react";
import "../Stylesheets/main.css";
import Autosuggest from "react-autosuggest";
import { useRef } from "react";

export default function AutoSuggestPostalBox({mailingAddress, esriToken}) {
    const [postalSuggestions, setPostalSuggestions] = useState([]); 
    const [postalAddress, setPostalAddress] = useState(mailingAddress);
    const timeoutRef = useRef(null);

    // Use AutoSuggest api from ARCGIS -- Postal Address
    function AutoSuggestFunction(value) {
        setTimeout(function(){

            if(value && value.length > 4) {
                var url = 'https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?f=json&text=' + value + '&token=' + esriToken + '&category=Address&countryCode=AUS';
                
                fetch(url, {method:  "POST"})
                .then(response => response.json())
                .then(response => {           
                    setPostalSuggestions(response.suggestions.map(row => ({
                        address: row.text
                    })));
                })
                .catch(error => console.log(error));
            }
        }, 200);
    }

    function handleAddressChange(value) {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setPostalAddress(value);

        timeoutRef.current = setTimeout(() => AutoSuggestFunction(value), 500);
    };

    return (
        <Autosuggest 
            inputProps={{
                autoComplete: "abcd",
                name: "postalAddress",
                id: "postalAddress",
                value: postalAddress,
                onChange: (_event, { newValue }) => {
                    handleAddressChange(newValue);
                },
                style: {fontWeight: '400'}
            }}
            suggestions={postalSuggestions}
            onSuggestionsFetchRequested={async ({ value }) => {
                if (!value) {
                    setPostalSuggestions([]);
                    return;
                }
            }}
            onSuggestionsClearRequested={() => {
                setPostalSuggestions([]);
            }}
            getSuggestionValue={suggestion => suggestion.address}
            renderSuggestion={suggestion => <div className="binSuggestion">
                {suggestion.address}
        </div>}
    />)
}